<button type="button" mat-icon-button aria-label="Quick Links" class="shortcuts-trigger" [matMenuTriggerFor]="menu">
  <lib-tess-icon size="var(--font-size-l)" class="plus-icon" icon="plus" sprite="mdi" />
</button>
<mat-menu #menu="matMenu" class="toolbar-menu">
  <div class="quick-links">
    <span>Quick links</span>
  </div>
  @for (option of options; track option.link) {
    <div (click)="navigate(option.link)" class="quick-link-option">
      <lib-tess-icon [icon]="option.icon" class="mr-2" />
      <div>
        <div class="option-title">{{ option.title }}</div>
        <div>{{ option.description }}</div>
      </div>
    </div>
  }
</mat-menu>
